import { render } from "./AppDefaultsManager.vue?vue&type=template&id=1d125995&scoped=true&lang=pug"
import script from "./AppDefaultsManager.vue?vue&type=script&lang=ts"
export * from "./AppDefaultsManager.vue?vue&type=script&lang=ts"

import "./AppDefaultsManager.vue?vue&type=style&index=0&id=1d125995&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d125995"

export default script